<template>
  <div class="red-dot dot-box" :style="style" v-if="type == 'dot'"></div>
  <div class="red-dot dot-hand" :style="style" v-else-if="type == 'hand'"></div>
  <div class="red-dot dot-new" :style="style" v-else></div>
</template>
<script>
export default {
  name: "dot",
  data() {
    return {
      dotShow: false,
    };
  },
  props: {
    top: {
      type: [String, Number],
    },
    left: {
      type: [String, Number],
    },
    right: {
      type: [String, Number],
    },
    type: {
      type: String,
      default: "dot", // dot | hand | new
    },
  },
  computed: {
    style() {
      if (this.left != "noSet") {
        return { top: this.top + "rem", left: this.left + "rem" };
      } else if (this.right != "noSet") {
        return { top: this.top + "rem", right: this.right + "rem" };
      } else {
        return { top: this.top + "rem", right: "0" };
      }
    },
  },
  methods: {
    hide() {
      this.$nextTick(() => {
        this.dotShow = false;
      });
    },
    show() {
      this.$nextTick(() => {
        this.dotShow = true;
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.red-dot {
  position: absolute;
  z-index: 99;
  pointer-events: none;
}
.dot-box {
  @include bgImg("icon/icon-new_dot.png");
  width: 0.24rem;
  height: 0.24rem;
}
.dot-hand {
  @include bgImg("icon/icon-new_dot_2.png");
  width: 0.68rem;
  height: 0.68rem;
  animation: flash 1.5s infinite;
  filter: drop-shadow(0 0 0.1rem #fff8cd);
}
.dot-new {
  @extend .icon-newtext;
  width: 0.77rem;
  height: 0.22rem;
}
</style>